import { Component, Input } from '@angular/core';

@Component({
  selector: 'dp-input-field',
  standalone: true,
  imports: [],
  templateUrl: './dp-input-field.component.html',
  styleUrl: './dp-input-field.component.scss'
})
export class DpInputFieldComponent {
  @Input() public placeholderLevel:any;
  @Input() public customeClassName: string = '';
}
